import { EventType, trackEventWithCommonProps } from "@utils/eventTracker";

type EventContext = {
  pageType?: string;
  cityName?: string;
  brandName?: string;
  modelName?: string;
  variantName?: string;
  colorName?: string;
  customerName?: string;
  email?: string;
  phone?: string;
  carAvailability?: string;
};

const toVehicleProperties = (context: EventContext) => ({
  city_name: context.cityName || "",
  vehicle_make: context.brandName || "",
  vehicle_model: context.modelName || "",
  vehicle_variant: context.variantName || "",
  vehicle_color: context.colorName || "",
  customer_name: context.customerName || "",
  email: context.email || "",
  phone: context.phone || "",
  car_availability: context.carAvailability || "",
});

export const trackAppFlowEvent = (
  eventName: "action" | "view" | "exception",
  context: EventContext,
  properties: Record<string, unknown> = {},
) =>
  trackEventWithCommonProps(
    eventName,
    eventName === "view" ? EventType.PAGE_EVENT : EventType.TRACK_EVENT,
    {
      pageType: context.pageType,
      additionalProps: {
        ...toVehicleProperties(context),
        ...properties,
      },
    },
  );

export const trackAppFlowAction = (
  context: EventContext,
  properties: Record<string, unknown>,
) => trackAppFlowEvent("action", context, properties);

export const trackAppFlowView = (
  context: EventContext,
  properties: Record<string, unknown>,
) => trackAppFlowEvent("view", context, properties);

export const trackAppFlowException = (
  context: EventContext,
  properties: Record<string, unknown>,
) => trackAppFlowEvent("exception", context, properties);

export const getLeadActionName = (status?: string) =>
  status?.toLowerCase().includes("update") ? "lead_updated" : "lead_created";
